import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMegaphone2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMegaphone2"><Path d="M10.5 7.5H6C3.79086 7.5 2 9.29086 2 11.5C2 13.7091 3.79086 15.5 6 15.5H10.5" stroke="currentColor"/><Path d="M18 8.5H19C20.6569 8.5 22 9.84315 22 11.5C22 13.1569 20.6569 14.5 19 14.5H18" stroke="currentColor"/><Path d="M18.5 3.5L10.5 7.5V15.5L18.5 19.5V3.5Z" stroke="currentColor"/><Path d="M12.5 16.5V21.5H8.5V15.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconMegaphone2;
